// @flow

import type { BankList, PaymentOption } from './types';
import type { CheckoutPaymentOptionsV2 } from '@tectonics/prs/incoming-payment';

export function getSafeEWalletPaymentOption(paymentOptions: ImmutableArray<PaymentOption> | CheckoutPaymentOptionsV2): BankList {
  if (!Array.isArray(paymentOptions) && Array.isArray(paymentOptions.ewallet_bank_list)) {
    return paymentOptions.ewallet_bank_list;
  }

  const paymentOption = Array.isArray(paymentOptions) && paymentOptions.find(paymentOption => paymentOption.id === 'ewallet');

  if (!paymentOption)
    throw new Error('Payment options: there is no `EWallet` in available options list');

  if (paymentOption.id !== 'ewallet')
    throw new Error(`Payment options: obtained payment option "${paymentOption.id}" is not EWallet`);

  return paymentOption.bank_list;
}
